import { minutesToMs } from '../helpers';

export const JWT_TOKEN_KEY = 'jwt';

const apiPath = '/api/v1/';
const apiDomain =
	process.env.REACT_APP_API_DOMAIN || 'http://backyard2017server.dev';
export const API_URL = apiDomain + apiPath;

export const API_SECONDS_UNTIL_INVALID =
	process.env.REACT_APP_API_SECONDS_UNTIL_INVALID || 60;

export const MS_UNTIL_IDLE = minutesToMs(
	process.env.REACT_APP_MINUTES_UNTIL_IDLE || 30
);

export const MS_JWT_TOKEN_EXPIRATION = minutesToMs(
	process.env.REACT_APP_MINUTES_JWT_COOKIE_TIME || 30
);

export const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE === 'true';
export const MAINTENANCE_MESSAGE = process.env.REACT_APP_MAINTENANCE_MESSAGE || '';

export const GROUP_IDS = {
	coordinator: 3,
	writer: 4,
	qsrDelegatable: 5,
	brommaSpreaderDivision: 6,
	frontline: 7,
	customer: 8,
	qsrFactory: 9,
	orderProcessing: 13,
	specialSoftware: 27,
	externalReader: 33,
	externalWriter: 34,
	supervisor: 40,
};

export const HIDE_CR_SECTIONS_IDS = {
	GREENZONE: 8500,
};



// WEBPACK FOOTER //
// ./src/constants/index.js